import DateUtils from "@date-io/moment";
import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
} from "@material-ui/core";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import React, { forwardRef } from "react";
import Carregando from "../../Pagina/Carregando";

const Parcelas = forwardRef((props, ref) => {
	const inputHandler = (field, value, index) => {
		let data = [];
		console.log(field);

		if (
			field[0] === "dVencimento" &&
			index === props.installmentsData.length - 1
		) {
			const dataMinima = moment(value).add(1, "d").format("YYYY-MM-DD");
			const dEntrega = moment(props.formData.dEntrega).format("YYYY-MM-DD");
			props.setMinDate(dataMinima);

			if (dEntrega < dataMinima)
				props.setFormData({
					...props.formData,
					dEntrega: dataMinima,
				});
		}

		props.installmentsData.map((item, i) => {
			if (i !== index) {
				data.push({
					cParcela: item.cParcela,
					dVencimento: item.dVencimento,
					cTipo: item.cTipo,
					nValor: item.nValor,
				});
			} else {
				data.push({
					...item,
					[field]: value,
				});
			}
			return true;
		});
		props.setInstallmentsData(data);
	};

  if(props?.loadingRefresh){
    return (
      <React.Fragment>
        <Carregando />
      </React.Fragment>
    );
  }

	return (
		<React.Fragment>
			<Paper className="p-1">
				{props.installmentsData && props.installmentsData.length === 0 && (
					<h4>Selecione a condição de pagamento</h4>
				)}
				{props.installmentsData &&
					props.installmentsData.length > 0 &&
					props.installmentsData.map((item, i) => {
						return (
							<Grid key={i} container spacing={3}>
								<Grid item md={2}>
									<TextField
										id={"cParcela"}
										label={"Parcela"}
										type={"text"}
										autoComplete="off"
										fullWidth
										required
										disabled
										value={
											props.installmentsData[i]["cParcela"]
												? props.installmentsData[i]["cParcela"]
												: item.cParcela
										}
										onChange={(e) =>
											inputHandler(["cParcela"], e.target.value, i)
										}
										inputProps={{
											maxLength: 40,
										}}
									/>
								</Grid>
								<Grid item md={3}>
									<MuiPickersUtilsProvider utils={DateUtils}>
										<KeyboardDatePicker
											fullWidth
											autoOk
											disablePast
											variant="dialog"
											format="DD/MM/YYYY"
											id={"dVencimento"}
											label={"Data do vencimento"}
											value={
												props.installmentsData[i]["dVencimento"]
													? moment(props.installmentsData[i]["dVencimento"])
													: moment(item.dVencimento)
											}
											onChange={(e) => inputHandler(["dVencimento"], e, i)}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item md={3}>
									<FormControl fullWidth margin="none">
										<InputLabel>Tipo</InputLabel>
										<Select
											id={"cTipo"}
											fullWidth
											required
											value={
												props.installmentsData[i]["cTipo"]
													? props.installmentsData[i]["cTipo"]
													: item.cTipo
											}
											onChange={(e) =>
												inputHandler(["cTipo"], e.target.value, i)
											}
										>
											<MenuItem value={"BOL"}>Boleto</MenuItem>
											<MenuItem value={"CC"}>Cartão de Credito</MenuItem>
											<MenuItem value={"TF"}>Transferência</MenuItem>
											<MenuItem value={"FI"}>Financiamento</MenuItem>
											{/* <MenuItem value={"CH"}>Cheque</MenuItem> */}
										</Select>
									</FormControl>
								</Grid>
								<Grid item md={3}>
									<TextField
										id={"nValor"}
										label={"Valor"}
										error={false}
										type={"text"}
										margin="none"
										autoComplete="off"
										fullWidth
										required
										value={
											props.installmentsData[i]["nValor"]
												? props.installmentsData[i]["nValor"]
												: item.nValor
										}
										onChange={(e) =>
											inputHandler(["nValor"], e.target.value, i)
										}
										inputProps={{
											maxLength: 40,
										}}
									/>
								</Grid>
							</Grid>
						);
					})}
			</Paper>
		</React.Fragment>
	);
});

export default Parcelas;
